/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */

export type SubClassificationEnum = typeof SubClassificationEnum[keyof typeof SubClassificationEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubClassificationEnum = {
  operating_income: 'operating_income',
  operational: 'operational',
  organizational: 'organizational',
  gain: 'gain',
  loss: 'loss',
  return_of_capital: 'return_of_capital',
  management_fees: 'management_fees',
  expenses: 'expenses',
  carried_interest: 'carried_interest',
  income_dividends: 'income_dividends',
  fee_offset: 'fee_offset',
  offering_costs: 'offering_costs',
} as const;
